import React from 'react';
import { Text, Card, Alert } from '@smarterservices/smarter-ui';
import { getStore } from '../../../stores/StoreContext';
import CONSTANTS from '../../../config/constants';
const ProctorNotes = (props) => {
  const ExamSession = getStore('examSessionStore');
  return (
    <Card {...props}>
      <Card.Header
        background="brand"
        padding={CONSTANTS.STYLES.CARD_HEADER_PADDING}
      >
        <Card.Title>
          <Text variant={CONSTANTS.STYLES.CARD_TITLE_VARIANT}>
            Proctor Notes
          </Text>
        </Card.Title>
      </Card.Header>
      <Card.Body padding={CONSTANTS.STYLES.CARD_BODY_PADDING}>
        {ExamSession.sessionData.examConfiguration.proctorNotes && (
          <Alert variant="warning" hasShadow={false}>
            These notes are only visible to the proctor.
          </Alert>
        )}
        <Text variant={CONSTANTS.STYLES.CARD_BODY_TEXT_VARIANT}>
          {ExamSession.sessionData.examConfiguration.proctorNotes
            ? ExamSession.sessionData.examConfiguration.proctorNotes
            : 'No notes provided'}
        </Text>
      </Card.Body>
    </Card>
  );
};

export default ProctorNotes;
